import React from "react";
import ReactDOM from "react-dom/client";
import "@/styles/proxnova-shell.css";
import "@/styles/proxnova-portal.css";
import "@/styles/proxnova-devices.css";
import "@/styles/proxnova-pages.css";
import "@/index.css";
import App from '@/app/App';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
